import { MARKETPLACE_TAB } from 'constants/marketplace';

export const featuredVehiclesInitialState = {
	isLoading: false,
	errorMessage: '',
};

export const initialOfferState = {
	offerStateLoading: false,
	offerStateErrorMessage: '',
	offerStateRequestId: null,
};

export const initSearchList = (searchListKey, listConfig = {}) => ({
	[searchListKey]: {
		currentSearch: { params: { page: 1 } },
		totalElements: 0,
		isReady: false, // will be true once the first load is ended
		isLoading: false,
		...initialOfferState,
		makes: [],
		pageCount: 0,
		errorMessage: '',
		vehicleIds: [],
		itemsPerPage: 30,
		listConfig: {
			reloadSearchOnHide: true,
			removeOnHide: true,
			...listConfig,
		},
		// Featured
		featured: { ...featuredVehiclesInitialState },
	},
});

export default {
	searchLists: {
		...initSearchList(MARKETPLACE_TAB.marketplace),
		...initSearchList(MARKETPLACE_TAB.offers, { reloadSearchOnHide: true, removeOnHide: false }),
		...initSearchList(MARKETPLACE_TAB.watchlist),
		...initSearchList(MARKETPLACE_TAB.following),
		...initSearchList(MARKETPLACE_TAB.hidden),
	},
};
